var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delete Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CMHC_UI-Kit_Iconography",
    transform: "translate(-162.000000, -4140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon--Delete",
    transform: "translate(162.000000, 4140.000000)",
    fill: "#282828"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8,3 C24.5844324,3 26.0351351,4.6825 26.0351351,6.75 L26.0351351,6.75 L26.0351351,8 L34,8 L34,10.5 L33.0351351,10.5 L33.0351351,33.4166667 C33.0351351,35.9441667 31.2696216,38 29.1,38 L29.1,38 L10.9,38 C8.73037838,38 6.96486486,35.9441667 6.96486486,33.4166667 L6.96486486,33.4166667 L6.96486486,10.5 L6,10.5 L6,8 L13.9648649,8 L13.9648649,6.75 C13.9648649,4.6825 15.4155676,3 17.2,3 L17.2,3 Z M30.7648649,10.5 L9.23513514,10.5 L9.23513514,33.4166667 C9.23513514,34.565 9.98205405,35.5 10.9,35.5 L10.9,35.5 L29.1,35.5 C30.0179459,35.5 30.7648649,34.565 30.7648649,33.4166667 L30.7648649,33.4166667 L30.7648649,10.5 Z M27.225,15.25 L27.225,31.875 L24.675,31.875 L24.675,15.25 L27.225,15.25 Z M21.275,15.25 L21.275,31.875 L18.725,31.875 L18.725,15.25 L21.275,15.25 Z M15.325,15.25 L15.325,31.875 L12.775,31.875 L12.775,15.25 L15.325,15.25 Z M22.8,5.5 L17.2,5.5 C16.668,5.5 16.2351351,6.06083333 16.2351351,6.75 L16.2351351,6.75 L16.2351351,8 L23.7648649,8 L23.7648649,6.75 C23.7648649,6.06083333 23.332,5.5 22.8,5.5 L22.8,5.5 Z",
    id: "Combined-Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.7cae50c8f708e1cb06bf9b22e5b29b09.svg";
export { ForwardRef as ReactComponent };